import React from 'react';
import * as S from './styles';
import { ICardPaintProjectProps } from '../cardPaintProject';
import FavoriteButton from '../../../favoriteButton/favoriteButton';
import { StatusQuoteSupplierItem } from '@/main/services/enum/StatusQuoteSupplierItem';
import { isNullUndefined, isShowControlByElementId } from '@/main/services/utils';
import { PartTypeEnum } from '@/main/services/enum/PartTypeEnum';
import StarRatingPartially from '../../../starRating/starRatingPartially';
import { Controls } from '@/main/services/constants/constantsControl';
import PriceDiffPercent from '../../../priceDiffPercent/priceDiffPercent';
import { formatCurrency } from '@/main/services/utilsNumber';
import CountControl from '../../../countControl/countControl';
import { useCreateOrderContext } from '@/main/screens/order/createorder/context';
import KOGButtonsTriggerPaintProject from '../../../kogButtonsTriggerPaintProject/kogbuttonsTriggerPaintProject';
import { PartSearchResponse } from '@/main/models/response';

function RowCardPaintProject({
  selectSupplier,
  partInCart
}: ICardPaintProjectProps) {
  const {
    integration,
    isQuoteOpen,
    isQuoteManual,
    partGuid,
    guidQuote
  } = useCreateOrderContext();

  const isBlocked =
    (selectSupplier.shipingIntegrationIsUnavailable) ||
    selectSupplier.idQuoteSuppItemStatus === StatusQuoteSupplierItem.Pending ||
    selectSupplier.notQuoted ||
    !selectSupplier.price ||
    isNullUndefined(selectSupplier.deliveryDays);

  const showPrices = isShowControlByElementId(Controls.IdShowPrices);

  const renderPartTypeAndPartBrand = () => {
    if (!selectSupplier.idPartType || !selectSupplier.partType) {
      return ''
    }

    if (selectSupplier.idPartType !== PartTypeEnum.OEM) {
      const partBrandDescription = selectSupplier.partBrandDescription ? `(${selectSupplier.partBrandDescription})` : ''
      return `${selectSupplier.partType} ${partBrandDescription}`;
    }

    return `${selectSupplier.partType}`;
  }

  function mapSelectSupplierToPart(): PartSearchResponse {
    return {
      guid: partGuid,
      isPaintType: selectSupplier.idPartType === PartTypeEnum.Paint,
      partCategoryName: selectSupplier.partCategoryName,
      partName: selectSupplier.partTitle,
      partSubCategoryName: selectSupplier.partSubCategoryName
    }
  }
  return (
    <S.WrapperCardShoppingRow>
      <S.ContainerCardShoppingRow $isRecommended={selectSupplier.isRecomendedSupplier}>
        {selectSupplier.image && (
          <div className="products-list__column products-list__column--image">
            <img src={selectSupplier.image} alt="" />
          </div>
        )}
        <div className="products-list__column products-list__column--supplier">
          <span title={selectSupplier.supplier}>{selectSupplier.supplier}</span>
          <FavoriteButton
            isFavorite={selectSupplier.isFavoriteSupplier}
            onToggleFavorite={() => { }}
            notClickable={isBlocked}
          />
        </div>
        {!isBlocked && (
          <>
            <div className="products-list__column products-list__column--sku">
              {selectSupplier.partCode || ''}
            </div>
            <div className="products-list__column products-list__column--partyType">
              {renderPartTypeAndPartBrand()}
            </div>
            <div className="products-list__column products-list__column--product">
              {selectSupplier.partTitle}
            </div>
            <div className="products-list__column products-list__column--deliveryTime">
              {selectSupplier.deliveryDays}
            </div>
            <div className="products-list__column products-list__column--rating">
              <StarRatingPartially rating={!isNullUndefined(selectSupplier.score) ? selectSupplier.score : 0} />
            </div>
            {selectSupplier.price !== undefined ? (
              <div className="products-list__column products-list__column--price">
                {showPrices && formatCurrency(selectSupplier.price)}
                {!isNullUndefined(selectSupplier.priceDiffPercent) && (
                  <PriceDiffPercent
                    diffPercent={Number(selectSupplier.priceDiffPercent)}
                  />
                )}
              </div>
            ) : (
              <div className="products-list__column products-list__column--price"></div>
            )}

            <div className="products-list__column products-list__column--addToCart">
              {partInCart ? (
                <CountControl
                  removeArrow
                  initialCount={partInCart.quantity}
                  maxCount={partInCart.stock}
                />
              ) : (
                <KOGButtonsTriggerPaintProject
                  guidQuote={String(guidQuote)}
                  part={mapSelectSupplierToPart()}
                />

              )}
            </div>
          </>
        )}

      </S.ContainerCardShoppingRow>
    </S.WrapperCardShoppingRow>

  );
}

export default RowCardPaintProject